/** QR code for "continue on your phone" (section 14b, desktop only). Rendered locally: no third-party request. */
import qrcode from "qrcode-generator";
import { t } from "@wapadesk/i18n";

/** SVG path of the code, or undefined when the text cannot be encoded (never throws). */
export function qrPath(text: string): { d: string; n: number } | undefined {
  try {
    const qr = qrcode(0, "M");
    qr.addData(text);
    qr.make();
    const n = qr.getModuleCount();
    let d = "";
    for (let r = 0; r < n; r++)
      for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c} ${r}h1v1h-1z`;
    return { d, n };
  } catch {
    return undefined;
  }
}

export function Qr({ text, locale, hint }: { text: string; locale: string; hint?: string }) {
  const code = qrPath(text);
  if (!code) return null;
  const { d, n } = code;
  return (
    <figure class="qr">
      <svg
        viewBox={`0 0 ${n} ${n}`}
        width="140"
        height="140"
        role="img"
        aria-label={t(locale, "chrome.continueOnPhone")}
      >
        <path d={d} fill="#111" />
      </svg>
      <figcaption class="small muted">
        {t(locale, "chrome.continueOnPhone")}
        {hint && (
          <>
            <br />
            {hint}
          </>
        )}
      </figcaption>
    </figure>
  );
}
